import React from 'react';
import { View, ScrollView, Text, Alert, TextInput } from 'react-native';
import { connect } from 'react-redux';

import post from "../../api/methods/post";
import { CREATE_USER_DELIVERABLE } from "./api/deliveryEndpoints";

import Colors from "../../constants/Colors";
import { stringIsEmpty } from "../../constants/StringChecker";

import { Spacing, Card, ButtonWithSpinner, InformationDialogue, SpinnerDialogue } from "../../components";
import NavBar from "../../components/NavBar";
import ImageSelector from "./ImageSelector";

class PlayerDeliveryComposer extends React.Component {

    state = {
        title: "",
        description: "",
        images: [
            { image: null, index: 0 },
        ],

        isSending: false,

        showErrorModal: false,
        errorMessage: "",
        showSuccessModal: false,
    }

	onImageChange = (file) => {

		// make a copy of the old array
		let newImages = Array.from(this.state.images);

		// insert new image one place before the add button
		newImages.splice(newImages.length -1, 0, { image: file, index: 0 })

		this.setState({ images: newImages });
	}

	onImageRemove = (array, index) => {

		// make a copy of the old array
		let newArray = Array.from(array);

		// remove item from the copy
		newArray.splice(index, 1);

		// ensures the ordering prop of all items matches current positions
		newArray.forEach((item, index) => item.index = index);

		console.log(newArray)
		this.setState({ images: newArray });
	};

    handleSend = async () => {
    	if (this.state.isSending) return;

        if (stringIsEmpty(this.state.title) || stringIsEmpty(this.state.description)) {
            this.setState({
                showErrorModal: true,
                errorMessage: "É necessário preencher os campos de Título e Descrição!"
            });
            return;
        }

        const images = Array.from(this.state.images);
        images.pop();

        this.setState({ isSending: true });

        try {

            const payload = {
                journeyId: this.props.journeyId,
                userId: this.props.userId,
                title: this.state.title,
                description: this.state.description,
                images: images,
            }

            let result = await post(CREATE_USER_DELIVERABLE, payload);

            this.setState({
                showSuccessModal: true,
            })

        } catch (e) {
            console.log(e);
            this.setState({
                showErrorModal: true,
                errorMessage: "Aconteceu um erro ao enviar a sua aplicação! Já estamos procurando o que deu de errado!"
            })
        }

        this.setState({ isSending: false });
    }

    render() {
        return (
            <NavBar title={"Criar uma nova aplicação"}>

                <InformationDialogue
                    isModalVisible={this.state.showErrorModal}
                    titleText={"Erro"}
                    descriptionText={this.state.errorMessage}
                    onClose={() => this.setState({ showErrorModal: false })}
                />

                <InformationDialogue
                    isModalVisible={this.state.showSuccessModal}
                    titleText={"Sucesso"}
                    descriptionText={"Sua aplicação foi enviada com sucesso!"}
                    buttons={[
                        {
                            text: "Voltar",
                            onPress: () => this.props.history.goBack()
                        }
                    ]}
                />

                <SpinnerDialogue
                    isModalVisible={this.state.isSending}
                    onClose={() => {}}
                    isFinished={!this.state.isSending}
                    titleProps={"Enviando sua aplicação!"}
                    messageProps={"Estamos enviando a sua aplicação!"}
                />

                <View style={{ padding: 18, paddingTop: 0, width: 600 }}>

                    <Text style={{ fontSize: 22, color: Colors.fontColorOnBackground }}>
                        Título:
                    </Text>
                    <TextInput
                        style={{ backgroundColor: Colors.cardBackgroundColor, color: 'white', minHeight: 40, maxHeight: 40, padding: 8, borderRadius: 8}}
                        value={this.state.title}
                        placeholder={"Título para a sua aplicação"}
                        placeholderTextColor={'white'}
                        onChangeText={(newValue) => this.setState({ title: newValue })}
                        maxLenght={80}
                    />

                    <Spacing height={12} />

                    <Text style={{ fontSize: 22, color: Colors.fontColorOnBackground }}>
                        Descrição:
                    </Text>
                    <TextInput
                        style={{ backgroundColor: Colors.cardBackgroundColor, color: 'white', minHeight: 140, maxHeight: 140, padding: 8, borderRadius: 8, textAlignVertical: 'top'}}
                        value={this.state.description}
                        placeholder={"Conte o que você fez baseado no que você aprendeu durante a jornada!"}
                        placeholderTextColor={'white'}
                        onChangeText={(newValue) => this.setState({ description: newValue })}
                        multiline
                    />

                    <Spacing height={12} />

                    <Text style={{ fontSize: 22, color: Colors.fontColorOnBackground }}>
                        Imagens:
                    </Text>
                    <Card containerStyle={{ flexDirection: 'row', alignItems: 'center', justifyContent: 'space-around', width: '100%' }}>
                    	<ScrollView horizontal={true}>
                        {
                            this.state.images.map((item, index, array) => {
                                return (
                                    <ImageSelector
                                        key={index}
                                        image={item.image}
                                        onImageChange={this.onImageChange}
                                        onImageRemove={() => this.onImageRemove(array, index)}
                                        index={index}
                                    />
                                )
                            })
                        }
                        </ScrollView>
                    </Card>

                    <Spacing height={12} />

                    <ButtonWithSpinner
                        isLoading={this.state.isSending}
                        text={'Enviar'}
                        onPress={this.handleSend}
                        containerPropsStyle={{ height: 30, borderRadius: 8, }}
                        textPropsStyle={{ fontSize: 18 }}
                    />


                </View>

            </NavBar>
        )
    }
}

const mapStateToProps = state => {
    return {
        userId: state.user.userId,
        journeyId: state.journey.currentJourney.id
    }
}

export default connect(mapStateToProps)(PlayerDeliveryComposer);
